// extracted by mini-css-extract-plugin
export default {"parkWebLander":"ParkWebLayout_parkWebLander__rQVL1","getDomainSection":"ParkWebLayout_getDomainSection__QNxX1","adContent":"ParkWebLayout_adContent__PdT6x"};